module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/93c7712476f6630cac7dd8bde9bf6e0a.png";